exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.alert-message-out{\r\n\tborder-bottom: solid 1px #1c869a;\r\n\tborder-left: solid 1px #1c869a;\r\n\tpadding: 0 0 3px 3px;\n}\n.alert-message{\r\n\tborder: solid 1px #1c869a;\r\n\tpadding: 0 5px 0 5px;\r\n\tfont-size: 13px;\n}\n.alert-message-in{\r\n\tborder-bottom: solid 1px gray;\r\n\tborder-left: solid 1px gray;\r\n\tpadding: 0 0 3px 3px;\n}\n.alert-message-fine{\r\n\tborder: solid 1px gray;\r\n\tpadding: 0 5px 0 5px;\r\n\tfont-size: 13px;\n}\n.icon-size {\r\n\twidth: 18px;\r\n\theight: 18px;\n}\r\n", ""]);

// exports
